import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile02BarGraph = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3333 7.33203V11.9987C13.3333 13.4715 12.1394 14.6654 10.6667 14.6654H5.33332C3.86056 14.6654 2.66666 13.4715 2.66666 11.9987V3.9987C2.66666 2.52594 3.86056 1.33203 5.33332 1.33203H7.33332M13.3333 7.33203V6.66536C13.3333 3.71985 10.9455 1.33203 7.99999 1.33203H7.33332M13.3333 7.33203C13.3333 6.22746 12.4379 5.33203 11.3333 5.33203L10.9333 5.33203C10.6856 5.33203 10.5617 5.33203 10.4581 5.31562C9.88755 5.22525 9.4401 4.7778 9.34974 4.20728C9.33332 4.10363 9.33332 3.97977 9.33332 3.73203V3.33203C9.33332 2.22746 8.43789 1.33203 7.33332 1.33203M7.99999 11.9987L7.99999 7.33203M10.6667 11.9987V8.66536M5.33332 11.9987V10.6654",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgFile02BarGraph);
export default ForwardRef;
